import React, { useState, useEffect, useRef } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { useParams } from "react-router-dom";

import AuthService from "services/auth.service";
import { Row, Col } from "reactstrap";



const CreateTransaction = () => {
  const { id } = useParams();
  const form = useRef();
  const checkBtn = useRef();
  
  const initialUserState = {
    title: "",
    totalFee: 0,
    refundableFee: 0,
    
  };

  const [currentUser, setCurrentUser] = useState(initialUserState);
  const [successful, setSuccessful] = useState(false);
  const [message, setMessage] = useState("");


  const getUser = (id) => {
    AuthService.get(id)
      .then((response) => {
        setCurrentUser(response.data);
        //console.log(response.data);
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  useEffect(() => {
    if (id) getUser(id);
  }, [id]);

  // const handleInputChange = (event) => {
  //   const { name, value } = event.target;
  //   setCurrentUser({ ...currentUser, [name]: value });
  // };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentUser((currentUser) => ({
      ...currentUser,
      [name]: value,
    }));
  };

  const myInlineStyles = {
    padding: "20px",
  };

  const handleRegister = (e) => {
    e.preventDefault();

    setMessage("");
    setSuccessful(false);

    form.current.validateAll();

    var data = {
             
             title: currentUser.title,
             totalFee: currentUser.totalFee,
             refundableFee: currentUser.refundableFee,
             paymentMethod: currentUser.paymentMethod,
             description: currentUser.description,
           };

    if (checkBtn.current.context._errors.length === 0) {
      AuthService.AddTransaction(currentUser.id, data)
      .then(
        (response) => {
          setMessage(response.data.message);
          setSuccessful(true);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setMessage(resMessage);
          setSuccessful(false);
        }
      );
    }
  };

  return (
    <div className="content">
      <Row>
        <Col>
          <div className="col-md-6 ">
            <div className="card card-container" style={myInlineStyles}>
              <Form onSubmit={handleRegister} ref={form}>
                {!successful && (
                  
                  <div>
                    <div className="form-group">
                      <label htmlFor="title">inputing transaction for </label>
                      <Input
                        type="text"
                        className="form-control"
                        name="title"
                        value={currentUser.email}
                        
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="title">Transaction Title</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="title"
                        value={currentUser.title}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="totalFee">Total Fee</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="totalFee"
                        value={currentUser.totalFee}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="paymentMethod">Payment Method</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="paymentMethod"
                        value={currentUser.paymentMethod}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="description">Description</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="description"
                        value={currentUser.description}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    
                    
                    {/* <div className="form-group">
                      <label htmlFor="refundableFee">Refundable Fee</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="refundableFee"
                        value={currentUser.refundableFee}
                        onChange={handleInputChange}
                        required
                      />
                    </div> */}

                    <div className="form-group">
                      <button className="btn btn-primary btn-block">
                        Create New Transaction
                      </button>
                    </div>
                  </div>
                )}

                {message && (
                  <div className="form-group">
                    <div
                      className={
                        successful
                          ? "alert alert-success"
                          : "alert alert-danger"
                      }
                      role="alert"
                    >
                      {message}
                    </div>
                  </div>
                )}
                <CheckButton style={{ display: "none" }} ref={checkBtn} />
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CreateTransaction;
